import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { BASEURL } from "../../../../../constants";
import axios from "axios";

const ImageRecognition = ({ setCurrentSlideData, contentId, data }) => {
  const [state, setState] = useState({
    image: "", // Store image URL
    imageKey: "",
    options: ["", "", "", ""],
    correctAnswer: null,
  });

  useEffect(() => {
    setCurrentSlideData((currentSlideData) => {
      let newCurrentSlideData = {
        ...currentSlideData,
        content: currentSlideData.content.map((contentObj) => {
          if (contentObj.id === contentId) {
            return { ...contentObj, data: state };
          } else {
            return contentObj;
          }
        }),
      };
      return newCurrentSlideData;
    });
  }, [state]);

  useEffect(() => {
    if (data) {
      setState(data);
    }
  }, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const uniqueId = uuidv4();
      const formData = new FormData();
      formData.append('image', file);
      formData.append('id', uniqueId);

      // Upload image
      await axios.post(`${BASEURL}/api/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // Fetch the uploaded image URL
      const imageResponseObject = await axios.get(`${BASEURL}/api/get-image`, {
        params: { imageId: uniqueId }
      });

      console.log(imageResponseObject, "Image response object");

      // Update state with the image URL and unique key
      setState((prev) => ({
        ...prev,
        image: imageResponseObject.data?.dataUrl || "",
        imageKey: uniqueId
      }));

    } catch (error) {
      console.error("Error uploading or fetching image:", error);
    }
  };


  const handleImageDelete = (image_key) => {
    if (image_key) {
      axios.delete(`${BASEURL}/api/delete-image`, {
        data: { key: image_key }
      })
        .then(() => {
          // Successfully deleted the image, reset state
          setState((prevState) => ({
            ...prevState,
            image: "", // Reset image URL
            imageKey: "",// Reset image key
            options: ["", "", "", ""],
            correctAnswer: null,

          }));
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          // Optionally, you can show an error message here
        });
    }
  };


  const handleOptionChange = (index, value) => {
    setState((prev) => {
      const updatedOptions = [...prev.options];
      updatedOptions[index] = value;
      return { ...prev, options: updatedOptions };
    });
  };

  const handleCorrectAnswerChange = (index) => {
    setState((prev) => ({ ...prev, correctAnswer: index }));
  };

  return (
    <div className="font-sans">
      <h1 className="text-2xl font-bold mb-4">Image Recognition</h1>
      <div className="mb-4 flex flex-col items-center">
        {state.image ? (
          <div className="relative w-full h-48">
            <img
              src={state.image}
              alt="Uploaded"
              className="w-full h-full object-contain rounded-md mb-2 border-[1px] border-gray-300 p-4 shadow-sm"
            />
            {/* Delete Button */}
            <button
              onClick={() => handleImageDelete(state.imageKey)}
              className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full shadow-md hover:bg-red-600 transition duration-300"
            >
              <span className="material-icons">Delete</span>
            </button>
          </div>
        ) : (
          <p className="text-gray-500 mb-2">No image uploaded</p>
        )}

        {/* Upload Image Input */}
        {!state.image && (
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full p-2 border border-gray-300 rounded-md hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
          />
        )}
      </div>


      {/* Options Grid (2 per row) */}
      <h3 className="text-lg font-medium mb-2">Options:</h3>
      <div className="grid grid-cols-2 gap-4">
        {state.options.map((option, index) => (
          <div key={index} className="relative">
            <input
              type="text"
              value={option}
              placeholder={`Option ${index + 1}`}
              onChange={(e) => handleOptionChange(index, e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md pl-8"
            />
            <input
              type="radio"
              name={contentId}
              checked={state.correctAnswer === index}
              onChange={() => handleCorrectAnswerChange(index)}
              className="absolute left-2 top-1/2 transform -translate-y-1/2"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageRecognition;